import { ProductsSection } from '@ui/product/products-section.tsx';
import { useNavigate } from 'react-router-dom';
import { useProducts } from '../../entites/product';

export const AllProducts = () => {
  const { data } = useProducts({});
  const navigate = useNavigate();

  return (
    <ProductsSection
      title="Все товары"
      isShowMore={false}
      items={data}
      onPress={() => navigate('/popular')}
    />
  );
};
